import axios from "axios";

const language = localStorage.getItem("language") || "en";
const instance = axios.create({
  baseURL:process.env.REACT_APP_LARAVEL_BACKEND_URL,
  headers: {
    "Content-type": "application/json",
    "X-localization": language,
    Accept: "application/json",
  },
});

export default instance;
